var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2935 53.7066C27.2935 53.7066 24.4402 36.7337 20.9185 33.2772C17.3967 29.8207 0.29345 27.2935 0.29345 27.2935C0.29345 27.2935 17.2663 24.4402 20.7228 20.9185C24.1793 17.3968 26.7065 0.293479 26.7065 0.293479C26.7065 0.293479 29.5598 17.2663 33.0815 20.7228C36.6033 24.1794 53.7066 26.7066 53.7066 26.7066C53.7066 26.7066 36.7337 29.5598 33.2772 33.0816C29.8207 36.6033 27.2935 53.7066 27.2935 53.7066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.1838,
    height: 38.1838,
    fill: "white",
    transform: "translate(27) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginStar);
export default __webpack_public_path__ + "static/media/login-star.9ab83f15da98db4e4fb3b65e70345188.svg";
export { ForwardRef as ReactComponent };